var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,1c-5.3,0-9.4,5-9.8,11H5.1c-1.1,0-2.1,1-2,2.1l1.7,30.2c0.1,2.6,2.3,4.7,5,4.7h30.4c2.6,0,4.8-2.1,5-4.7 l1.7-30.2c0.1-1.1-0.9-2.1-2-2.1H34.8C34.4,6,30.3,1,25,1z M25,3c4,0,7.4,3.9,7.8,9H17.2C17.6,6.9,21,3,25,3z M5.1,14h10.8 c0.1,0,0.2,0,0.3,0h17.7c0.1,0,0.2,0,0.3,0h10.8l-1.7,30.2c-0.1,1.6-1.4,2.8-3,2.8H9.8c-1.6,0-2.9-1.2-3-2.8L5.1,14L5.1,14z  M25.1,18c-4.3,0-7.6,2.7-7.6,6.3c0,4,3.7,5.4,7.1,6.6c4,1.5,6.4,2.6,6.4,5.7c0,2.4-2.7,4.4-6.1,4.4c-3.8,0-6.9-2.7-7-2.8l-1.1,1.6 c0.8,0.7,4.1,3.1,8.1,3.1c4.5,0,8.1-2.8,8.1-6.4c0-4.8-4.1-6.3-7.7-7.6c-3.6-1.3-5.8-2.3-5.8-4.8c0-2.5,2.4-4.3,5.6-4.3 c2.2,0,4,0.8,5.1,1.4c0.2,0.1,0.6,0.4,0.9,0.5l1-1.7C31.8,20.1,28.9,18,25.1,18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopee);
export default __webpack_public_path__ + "static/media/shopee.9efb5b3e.svg";
export { ForwardRef as ReactComponent };